// extracted by mini-css-extract-plugin
module.exports = {"ShippingEstimate":"shippingEstimate_ShippingEstimate__uOjAG","success":"shippingEstimate_success__2fNaX","error":"shippingEstimate_error__QTQcf"};